import { useEffect, useState } from 'react'

import { NamedItemInt, PagedFilter, deleteKeyword, getAllKeywords } from 'core'
import { KeywordResponse } from 'core'
import PagedList from 'core/application/commons/pagedList'

import { Button, Dropdown, Menu, MenuItem, Row, Table } from 'common/components'
import { useCommandRequestV2, useQueryRequestV2 } from 'common/hooks'

import DeleteKeywordModal from './DeleteKeywordModal'
import SaveKeywordModal from './SaveKeywordModal'

export const KEYWORD_MANAGEMENT = 'keyword-management'

const KeywordManagement = () => {
  const columns: any = [
    {
      title: 'Keyword',
      dataIndex: 'keyword',
      key: 'keyword',
      sorter: false,
      sortDirections: ['descend', 'ascend'],
      render: (item: string) => {
        return <>{item}</>
      },
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      sorter: false,
      sortDirections: ['descend', 'ascend'],
      render: (item: NamedItemInt) => {
        return <>{item.name}</>
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: false,
      sortDirections: ['descend', 'ascend'],
      render: (item: NamedItemInt) => {
        return <>{item.name}</>
      },
    },
    {
      title: 'Expense Types',
      dataIndex: 'expenseTypes',
      key: 'expenseTypes',
      sorter: false,
      sortDirections: ['descend', 'ascend'],
      render: (items: NamedItemInt[]) => {
        return (
          <>
            {items.map((item) => (
              <div>{item.name}</div>
            ))}
          </>
        )
      },
    },
    {
      title: 'Exceptions',
      dataIndex: 'exceptions',
      key: 'exceptions',
      sorter: false,
      sortDirections: ['descend', 'ascend'],
      render: (items: NamedItemInt[]) => {
        return (
          <>
            {items.map((item) => (
              <div>{item.name}</div>
            ))}
          </>
        )
      },
    },
    {
      title: 'Actions',
      key: 'action',
      className: 't-terminated-employees-action',
      render: (record: KeywordResponse) => (
        <>
          <Dropdown overlay={menu(record)}>
            <Button>...</Button>
          </Dropdown>
        </>
      ),
    },
  ]

  const [openEditModal, setOpenEditModal] = useState<boolean>(false)
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false)
  const [keywordId, setKeywordId] = useState<string | null>(null)
  const [keywordToDelete, setKeywordToDelete] = useState<KeywordResponse | null>(null)

  const [filter, setFilter] = useState<PagedFilter>({ pageNumber: 1, pageSize: 10 })
  const {
    data: keywords,
    sendQuery: sendGetAllKeywords,
    reload,
  } = useQueryRequestV2<PagedList<KeywordResponse>>({
    initialState: null,
    queryFn: () => getAllKeywords(filter),
  })

  const { sendCommand: deleteKeywordCommand } = useCommandRequestV2(deleteKeyword)

  useEffect(() => {
    ;(async () => {
      await reload()
    })()
  }, [filter])

  const onKeywordTableChange = (pagination: any) => {
    setFilter({
      ...filter,
      pageNumber: pagination.current,
      pageSize: pagination.pageSize,
    })
  }

  const handleEditModal = (keywordId: string) => {
    setKeywordId(keywordId)
    setOpenEditModal(true)
  }
  const handleDeleteModal = (record: KeywordResponse) => {
    setOpenDeleteModal(true)
    setKeywordToDelete(record)
  }

  const closeModalHandler = () => {
    setOpenEditModal(false)
  }

  const closeDeleteModalHandler = () => {
    setKeywordToDelete(null)
    setOpenDeleteModal(false)
  }

  const onOkSaveKeywordModal = async () => {
    setOpenEditModal(false)
    await sendGetAllKeywords()
  }

  const OnOkDeleteModal = async () => {
    setOpenDeleteModal(false)
    await deleteKeywordCommand(keywordToDelete.keywordId)
    await sendGetAllKeywords()
  }

  const menu = (record: KeywordResponse): JSX.Element => {
    return (
      <Menu>
        <MenuItem key={1}>
          <Button type="text" icon="fas fa-pencil" onClick={() => handleEditModal(record.keywordId)}>
            Edit
          </Button>
        </MenuItem>
        <MenuItem key={2}>
          <Button type="text" icon="fal fa-trash-alt" onClick={() => handleDeleteModal(record)}>
            Delete
          </Button>
        </MenuItem>
      </Menu>
    )
  }

  return (
    <>
      {keywords && (
        <>
          <Row>
            <Button type={'primary'} onClick={() => handleEditModal(null)}>
              Add New
            </Button>
          </Row>

          <Table
            dataSource={keywords.items}
            onChange={onKeywordTableChange}
            columns={columns}
            pagination={{
              total: keywords?.totalItemCount,
              pageSize: keywords?.pageSize,
              current: keywords?.pageNumber,
            }}
            rowKey={(record: KeywordResponse) => record.keywordId}
          />
        </>
      )}
      {openEditModal && (
        <SaveKeywordModal
          onCancel={closeModalHandler}
          keywordId={keywordId}
          visible={openEditModal}
          onOk={onOkSaveKeywordModal}
        />
      )}

      <DeleteKeywordModal
        onCancel={closeDeleteModalHandler}
        visible={openDeleteModal}
        onOk={OnOkDeleteModal}
        keyword={keywordToDelete?.keyword}
      />
    </>
  )
}

export default KeywordManagement
